export const MAX_MONTHLY_PERIOD = 120;
export const MAX_MONTHLY_PERIOD_GRADED = 1200;
export const MAX_YEARLY_PERIOD = 100;
